<template>
    <div
        class="site_content weeduc-admin-content main-container"
        :class="{ 'fixed-site-preview': positionFixedSite }"
    >
        <div
            class="container-form site demo"
            :class="{
                'fixed-site-left': positionFixedSite,
                'dark': websites.typeLayout == 0,
                'light': websites.typeLayout == 1,
            }"
        >
            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco1')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco1
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Banner
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco1_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco1">
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Imagem</label>
                        </div>
                        <div class="form-file">
                            <div class="file-wrapper primary">
                                <span class="thumbnail">
                                    <span class="icon">
                                        <svg
                                            width="46"
                                            height="39"
                                            viewBox="0 0 46 39"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></path>
                                            <rect
                                                x="1.00049"
                                                y="1.40454"
                                                width="43.9461"
                                                height="36.1909"
                                                rx="2.58507"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></rect>
                                            <circle
                                                cx="14.8948"
                                                cy="10.6676"
                                                r="3.71629"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></circle>
                                        </svg>
                                    </span>
                                    <span class="text">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <span class="text"> 1920x1080 </span>
                                </span>
                                <input
                                    class="form-control"
                                    type="file"
                                    @change="updateFilePathBanner1"
                                    accept=".png, .jpg, .jpeg, .webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Título:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Curso X - O melhor curso de matemática do mercado"
                                v-model="bloco1_title"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Endereço da URL:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="https://seucurso.com.br"
                                v-model="bloco1_link"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Descrição</label>
                        </div>
                        <div class="form-input">
                            <textarea
                                placeholder="Somos o maior curso de matemática..."
                                v-model="bloco1_description"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </section>

            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco2')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco2
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Listagem de Cursos
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco2_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco2">
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Título:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Veja o que os alunos estão dizendo"
                                v-model="bloco2_title"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco3')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco3
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Conteúdo Institucional
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco3_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco3">
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Imagem</label>
                        </div>
                        <div class="form-file">
                            <div class="file-wrapper primary">
                                <span class="thumbnail">
                                    <span class="icon">
                                        <svg
                                            width="46"
                                            height="39"
                                            viewBox="0 0 46 39"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></path>
                                            <rect
                                                x="1.00049"
                                                y="1.40454"
                                                width="43.9461"
                                                height="36.1909"
                                                rx="2.58507"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></rect>
                                            <circle
                                                cx="14.8948"
                                                cy="10.6676"
                                                r="3.71629"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></circle>
                                        </svg>
                                    </span>
                                    <span class="text">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <span class="text"> 1920x1080 </span>
                                </span>
                                <input
                                    class="form-control"
                                    type="file"
                                    @change="updateFilePathBanner3"
                                    accept=".png, .jpg, .jpeg, .webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Título:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Curso X - O melhor curso de matemática do mercado"
                                v-model="bloco3_title"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Endereço da URL:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="https://seucurso.com.br"
                                v-model="bloco3_link"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Descrição</label>
                        </div>
                        <div class="form-input">
                            
                            <div class="custom-quill-wrapper">
                                <QuillEditor
                                    v-model:content="bloco3_description"
                                    toolbar="essential"
                                    contentType="html"
                                    class="custom-quill-editor"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco4')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco4
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Depoimentos
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco4_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco4">
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Título:</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Curso X - O melhor curso de matemática do mercado"
                                v-model="titleDepoimentos"
                            />
                        </div>
                    </div>
                    <hr />
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Imagem</label>
                        </div>
                        <div class="form-file">
                            <div class="file-wrapper primary">
                                <span class="thumbnail">
                                    <span class="icon">
                                        <svg
                                            width="46"
                                            height="39"
                                            viewBox="0 0 46 39"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></path>
                                            <rect
                                                x="1.00049"
                                                y="1.40454"
                                                width="43.9461"
                                                height="36.1909"
                                                rx="2.58507"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></rect>
                                            <circle
                                                cx="14.8948"
                                                cy="10.6676"
                                                r="3.71629"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></circle>
                                        </svg>
                                    </span>
                                    <span class="text">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <span class="text"> 1920x1080 </span>
                                </span>
                                <input
                                    class="form-control"
                                    type="file"
                                    @change="updateFilePathDepoimento1"
                                    accept=".png, .jpg, .jpeg, .webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Nome</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Nome do aluno"
                                v-model="depoimentos[0].name"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Descrição</label>
                        </div>
                        <div class="form-input">
                            <textarea
                                placeholder="Depoimento do aluno..."
                                v-model="depoimentos[0].description"
                            ></textarea>
                        </div>
                    </div>
                    <hr />
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Imagem</label>
                        </div>
                        <div class="form-file">
                            <div class="file-wrapper primary">
                                <span class="thumbnail">
                                    <span class="icon">
                                        <svg
                                            width="46"
                                            height="39"
                                            viewBox="0 0 46 39"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></path>
                                            <rect
                                                x="1.00049"
                                                y="1.40454"
                                                width="43.9461"
                                                height="36.1909"
                                                rx="2.58507"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></rect>
                                            <circle
                                                cx="14.8948"
                                                cy="10.6676"
                                                r="3.71629"
                                                stroke="#9D9FA3"
                                                stroke-width="1.25714"
                                            ></circle>
                                        </svg>
                                    </span>
                                    <span class="text">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <span class="text"> 1920x1080 </span>
                                </span>
                                <input
                                    class="form-control"
                                    type="file"
                                    @change="updateFilePathDepoimento2"
                                    accept=".png, .jpg, .jpeg, .webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Nome</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Nome do aluno"
                                v-model="depoimentos[1].name"
                            />
                        </div>
                    </div>
                    <div class="form-group-container">
                        <div class="form-label">
                            <label>Descrição</label>
                        </div>
                        <div class="form-input">
                            <textarea
                                placeholder="Depoimento do aluno..."
                                v-model="depoimentos[1].description"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </section>

            <section class="config-form primary col-12">
                <div class="title site toggle" @click="toggleSection('bloco5')">
                    <h4>
                        <span class="toggle-icon">
                            <fa
                                class="fas"
                                :icon="
                                    sections.bloco5
                                        ? 'fa-chevron-down'
                                        : 'fa-chevron-up'
                                "
                            />
                        </span>
                        Redes Sociais
                    </h4>
                    <div class="form-check form-switch card-option-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            v-model="bloco5_active"
                        />
                    </div>
                </div>
                <div class="content-text" v-show="sections.bloco5">
                    <div class="form-group-container">
                        <div
                            class="col-form-inner col-12 col-md-12 col-lg-12 social"
                            v-for="(item, index) in names"
                            :key="index"
                        >
                            <div
                                class="social-form-group-container socialMedia"
                            >
                                <div class="description">
                                    <span>{{ item }}</span>
                                </div>
                                <div
                                    class="form-check form-switch card-option-switch"
                                >
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        v-model="activeSocial[index]"
                                        :id="'flexSwitchCheck' + index"
                                    />
                                </div>
                            </div>
                            <div class="social-form-group-container full">
                                <div class="form-input">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="www.facebook.com.br"
                                        v-model="linkSocial[index]"
                                        :disabled="!activeSocial[index]"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div
            class="row site demo"
            :class="{
                'fixed-site': positionFixedSite,
                'dark': websites.typeLayout == 0,
                'light': websites.typeLayout == 1,
            }"
        >
            <section
                class="config-form primary col-12"
                :class="!bloco1_active ? 'blur' : ''"
            >
                <div class="box_1">
                    <div class="banner">
                        <div class="banner-content">
                            <img
                                src="@/assets/1920x1080.png"
                                alt=""
                                v-show="!bloco1_banner"
                            />
                            <img
                                :src="bloco1_bannerPreview"
                                alt=""
                                v-show="bloco1_banner"
                            />
                            <div class="banner-text">
                                <h2>{{ bloco1_title }}</h2>
                                <p>{{ bloco1_description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section
                class="course-info config-form primary col-12 itens-courses"
                :class="!bloco2_active ? 'blur' : ''"
            >
                <p style="margin: 0px">{{ bloco2_title }}</p>
                <div class="box_2" v-for="i in 4" :key="i">
                    <div class="cursos">
                        <div class="banner-content cursos">
                            <img
                                :src="
                                    allCollections && allCollections.length > 0
                                        ? allCollections[
                                              (i - 1) % allCollections.length
                                          ].imageFinalPath2
                                        : require('@/assets/190x112.png')
                                "
                                alt="Imagem do curso"
                                style="
                                    width: 190px;
                                    height: 112px;
                                    object-fit: cover;
                                "
                            />
                            <!-- <div class="banner-text">
                <span v-if="allCollections && allCollections.length > 0">
                  {{ allCollections[(i - 1) % allCollections.length].name }}
                </span>
              </div> -->
                        </div>
                    </div>
                </div>
            </section>
            <section
                class="course-info config-form primary col-12 itens-courses"
                :class="!bloco3_active ? 'blur' : ''"
            >
                <div class="box_3">
                    <div class="cursos">
                        <div
                            class="banner-content cursos d-flex align-items-center"
                        >
                            <div class="banner-image" style="flex: 1">
                                <img
                                    src="@/assets/1920x1080.png"
                                    alt=""
                                    v-show="!bloco3_banner"
                                />
                                <img
                                    :src="bloco3_bannerPreview"
                                    alt=""
                                    v-show="bloco3_banner"
                                />
                            </div>
                            <div
                                class="banner-text"
                                style="flex: 1; position: static"
                            >
                                <h2>{{ bloco3_title }}</h2>
                                <p>{{ bloco3_description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- <section class="config-form primary col-12" :class="!bloco4_active?'blur':''">
        <div class="box_4">
          <div class="banner depoimentos">
            <h2 class="section-title">{{titleDepoimentos}}</h2>
            <div class="depoimentos-slider">
                <div v-for="(depoimento, index) in depoimentos" 
                     :key="index"
                     class="depoimento-slide">
                  <div class="depoimento-content">
                    <div class="depoimento-image">
                      <img :src="depoimento.preview ? depoimento.preview : require('@/assets/user.png')" alt="Foto depoimento" />
                    </div>
                    <div class="depoimento-text">
                      <h3 class="depoimento-nome">{{depoimento?.name ? depoimento.name : 'Nome...'}}</h3>
                      <p class="depoimento-descricao">{{depoimento?.description ? depoimento.description : 'Depoimento...'}}</p>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </section> -->
            <section
                class="config-form primary col-12"
                :class="!bloco4_active ? 'blur' : ''"
            >
                <div class="box_4">
                    <div class="banner depoimentos">
                        <h2 class="section-title">{{ titleDepoimentos }}</h2>
                        <div class="depoimentos-slider">
                            <button class="nav-button prev" @click="prevSlide">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 320 512"
                                >
                                    <path
                                        d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"
                                    />
                                </svg>
                            </button>
                            <div class="depoimento-slide">
                                <div class="depoimento-content">
                                    <div class="depoimento-image">
                                        <img
                                            :src="
                                                depoimentos[currentIndex]
                                                    ?.preview ||
                                                require('@/assets/user.png')
                                            "
                                            alt="Foto depoimento"
                                        />
                                    </div>
                                    <div class="depoimento-text">
                                        <h3 class="depoimento-nome">
                                            {{
                                                depoimentos[currentIndex]
                                                    ?.name || 'Nome...'
                                            }}
                                        </h3>
                                        <p class="depoimento-descricao">
                                            {{
                                                depoimentos[currentIndex]
                                                    ?.description ||
                                                'Depoimento...'
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <button class="nav-button next" @click="nextSlide">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 320 512"
                                >
                                    <path
                                        d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section
                class="config-form primary col-12"
                :class="!bloco5_active ? 'blur' : ''"
            >
                <div class="box_5">
                    <div class="logoPreview">
                        <img :src="websites.logoFinal" alt="" />
                    </div>
                    <div class="redes-sociais">
                        <div
                            class="rede-social"
                            v-for="(item, index) in names"
                            :key="index"
                            v-show="activeSocial[index]"
                        >
                            <a :href="linkSocial[index]" target="_blank">
                                <fa
                                    :icon="['fa-brands', getSocialIcon(item)]"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="buttons-container">
            <button
                type="button"
                @click="saveGeral"
                class="btn btn-block btn-content"
            >
                Salvar e Publicar
            </button>
            <button type="button" class="btn btn-block btn-content">
                Voltar
            </button>
            <button
                type="button"
                @click="clearCache()"
                class="btn btn-block btn-content"
            >
                Limpar Cache
            </button>
        </div>
    </div>
</template>

<script>
    import api from '@/utils/site';
    import websiteApi from '@/utils/Weflix/website';
    import apiSiteContent from '@/utils/Site/content';
    import apiSiteSocialMidia from '@/utils/Site/socialMidia';
    import apiTestimony from '@/utils/Site/testimony.js';
    import apiCollections from '@/utils/Weflix/collections';

    import apiAWS from '@/utils/storage/aws';
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';

    export default {
        data() {
            return {
                sections: {
                    bloco1: true,
                    bloco2: true,
                    bloco3: true,
                    bloco4: true,
                    bloco5: true,
                },
                listContents: [],
                currentSlide: 0,
                slideInterval: null,

                bloco1_active: false,
                bloco2_active: false,
                bloco3_active: false,
                bloco4_active: false,
                bloco5_active: false,

                bloco1_banner: '',
                bloco1_bannerPreview: null,
                bloco1_title: '',
                bloco1_link: '',
                bloco1_description: '',

                bloco2_title: '',

                bloco3_banner: '',
                bloco3_bannerPreview: null,
                bloco3_title: '',
                bloco3_link: '',
                bloco3_description: '',

                bloco4_title: '',

                positionFixedSite: false,

                idSite: null,

                activeSocial: Array(6).fill(false),
                linkSocial: Array(6).fill(''),
                names: [
                    'Facebook',
                    'Instagram',
                    'Youtube',
                    'Linkedin',
                    'Whatsapp',
                    'TikTok',
                ],

                titleDepoimentos: '',
                depoimentos: [
                    {
                        id: null,
                        name: '',
                        photo: '',
                        photoFinal: '',
                        description: '',
                    },
                    {
                        id: null,
                        name: '',
                        photo: '',
                        photoFinal: '',
                        description: '',
                    },
                ],
                allCollections: [],
                currentIndex: 0,
            };
        },
        computed: {
            ...mapState(['token', 'websites']),
        },
        methods: {
            async saveGeral() {
                try {
                    await this.save();
                    await this.saveDepoimentos();
                    await this.editSocialMedia();
                    toast.success('Dados atualizados com sucesso!');
                } catch (error) {
                    toast.error('Erro ao atualizar os dados');
                    console.error('Erro ao atualizar os dados:', error);
                }
            },
            toggleSection(section) {
                this.sections[section] = !this.sections[section];
            },
            getSocialIcon(rede) {
                const icons = {
                    Facebook: 'fa-facebook',
                    Instagram: 'fa-instagram',
                    Youtube: 'fa-youtube',
                    Linkedin: 'fa-linkedin',
                    Whatsapp: 'fa-whatsapp',
                    TikTok: 'fa-tiktok',
                };
                return icons[rede];
            },
            async putFileAws(url, file) {
                try {
                    const response = await apiAWS.putFileAWS(url, file);
                } catch (error) {
                    console.error('Erro ao enviar arquivo para AWS');
                }
            },
            async updateFilePathBanner1(event) {
                const file = event.target.files[0];
                this.bloco1_bannerPreview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.bloco1_banner = response.token;
                    console.debug(response);
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async updateFilePathBanner3(event) {
                const file = event.target.files[0];
                this.bloco3_bannerPreview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.bloco3_banner = response.token;
                    console.debug(response);
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async updateFilePathDepoimento1(event) {
                const file = event.target.files[0];
                this.depoimentos[0].preview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.depoimentos[0].photo = response.token;
                    console.log(this.depoimentos[0].photo);
                    console.debug(response);
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async updateFilePathDepoimento2(event) {
                const file = event.target.files[0];
                this.depoimentos[1].preview = URL.createObjectURL(file);

                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.depoimentos[1].photo = response.token;
                    console.log(this.depoimentos[1].photo);
                    console.debug(response);
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async save() {
                // Definir os blocos com a ordem correta
                const content_1 = {
                    type: 1, // Banner 1
                    title: this.bloco1_title,
                    description: this.bloco1_description,
                    pathImage: this.bloco1_banner,
                    url: this.bloco1_link,
                    order: 1,
                    status: this.bloco1_active == true ? 1 : 0,
                };

                const content_2 = {
                    type: 2, // Cursos
                    title: this.bloco2_title,
                    description: '',
                    pathImage: '',
                    url: '',
                    order: 2,
                    status: this.bloco2_active == true ? 1 : 0,
                };

                const content_3 = {
                    type: 3, // Banner 2 (Conteúdo Institucional)
                    title: this.bloco3_title,
                    description: this.bloco3_description,
                    pathImage: this.bloco3_banner,
                    url: this.bloco3_link,
                    order: 3,
                    status: this.bloco3_active == true ? 1 : 0,
                };

                const content_4 = {
                    type: 4, // Depoimentos
                    title: this.titleDepoimentos,
                    description: '',
                    pathImage: '',
                    url: '',
                    order: 4,
                    status: this.bloco4_active == true ? 1 : 0,
                };

                const putData = [];
                const postData = [];

                // Verifica quais blocos existem e quais precisam ser criados
                // Ordem: 1-Banner, 2-Cursos, 3-Banner2, 4-Depoimentos
                
                console.log('=== VERIFICANDO BLOCOS EXISTENTES ===');
                console.log('Blocos existentes na API:', this.listContents);
                
                // Bloco 1 (Banner) - type: 1, order: 1
                const existingBloco1 = this.listContents?.find(item => item.type === 1);
                if (existingBloco1?.id) {
                    content_1.id = existingBloco1.id;
                    putData.push(content_1);
                    console.log('✅ Bloco 1 (Banner): Atualizando existente');
                } else {
                    postData.push(content_1);
                    console.log('➕ Bloco 1 (Banner): Criando novo');
                }

                // Bloco 2 (Cursos) - type: 2, order: 2
                const existingBloco2 = this.listContents?.find(item => item.type === 2);
                if (existingBloco2?.id) {
                    content_2.id = existingBloco2.id;
                    putData.push(content_2);
                    console.log('✅ Bloco 2 (Cursos): Atualizando existente');
                } else {
                    postData.push(content_2);
                    console.log('➕ Bloco 2 (Cursos): Criando novo');
                }

                // Bloco 3 (Banner 2 - Conteúdo Institucional) - type: 3, order: 3
                const existingBloco3 = this.listContents?.find(item => item.type === 3);
                if (existingBloco3?.id) {
                    content_3.id = existingBloco3.id;
                    putData.push(content_3);
                    console.log('✅ Bloco 3 (Banner 2): Atualizando existente');
                } else {
                    postData.push(content_3);
                    console.log('➕ Bloco 3 (Banner 2): Criando novo');
                }

                // Bloco 4 (Depoimentos) - type: 4, order: 4
                const existingBloco4 = this.listContents?.find(item => item.type === 4);
                if (existingBloco4?.id) {
                    content_4.id = existingBloco4.id;
                    putData.push(content_4);
                    console.log('✅ Bloco 4 (Depoimentos): Atualizando existente');
                } else {
                    postData.push(content_4);
                    console.log('➕ Bloco 4 (Depoimentos): Criando novo');
                }

                // Verificar quantos blocos existem vs quantos precisam ser criados
                const totalItems = putData.length + postData.length;
                const existingCount = this.listContents?.length || 0;
                
                console.log(`=== RESUMO ===`);
                console.log(`Blocos existentes na API: ${existingCount}`);
                console.log(`Blocos para atualizar (PUT): ${putData.length}`);
                console.log(`Blocos para criar (POST): ${postData.length}`);
                console.log(`Total de operações: ${totalItems}`);
                
                // Se não há dados para enviar, algo está errado
                if (totalItems === 0) {
                    console.warn('⚠️ ATENÇÃO: Nenhum bloco para enviar!');
                    toast.warning('Nenhum bloco para enviar');
                    return;
                }

                console.log('Dados existentes (listContents):', this.listContents);
                console.log('Dados para PUT (atualizar):', putData);
                console.log('Dados para POST (criar):', postData);
                
                // Debug: verificar cada bloco individualmente
                console.log('Bloco 1 - Existente:', existingBloco1);
                console.log('Bloco 2 - Existente:', existingBloco2);
                console.log('Bloco 3 - Existente:', existingBloco3);
                console.log('Bloco 4 - Existente:', existingBloco4);

                try {
                    // Atualiza itens existentes
                    if (putData.length > 0) {
                        console.log('Executando PUT para', putData.length, 'itens existentes');
                        const putResponse = await apiSiteContent.putContentData(
                            this.token,
                            putData
                        );
                        console.log('PUT Response:', putResponse);
                    }
                    
                    // Cria novos itens
                    if (postData.length > 0) {
                        console.log('Executando POST para', postData.length, 'novos itens');
                        const postResponse = await apiSiteContent.postContentData(
                            this.token,
                            postData
                        );
                        console.log('POST Response:', postResponse);
                    }
                    
                    // Log de confirmação das operações
                    if (putData.length > 0) {
                        console.log(`✅ ${putData.length} blocos serão atualizados`);
                    }
                    if (postData.length > 0) {
                        console.log(`✅ ${postData.length} blocos serão criados`);
                    }
                    
                    console.log('Limpando cache e recarregando dados...');
                    await this.clearCache();
                    console.log('Cache limpo, aguardando 2 segundos antes de recarregar...');
                    
                    // Aguarda 2 segundos para garantir que o backend processou
                    await new Promise(resolve => setTimeout(resolve, 2000));
                    
                    console.log('Chamando getContetData...');
                    await this.getContetData();
                    console.log('getContetData concluído');
                    
                    // Teste adicional: verificar se os dados foram realmente salvos
                    console.log('=== TESTE ADICIONAL: Verificando dados após 5 segundos ===');
                    setTimeout(async () => {
                        try {
                            const testResponse = await apiSiteContent.getContentData(this.token);
                            console.log('=== DADOS APÓS 5 SEGUNDOS ===');
                            console.log('Quantidade de itens:', testResponse?.length);
                            console.log('Dados completos:', testResponse);
                        } catch (error) {
                            console.error('Erro no teste adicional:', error);
                        }
                    }, 5000);
                    
                } catch (error) {
                    toast.error('Erro ao salvar os dados');
                    console.error('Erro detalhado:', error);
                }
            },
            async clearCache() {
                try {
                    await api.clearCache(this.token);
                    toast.success('Cache limpo com sucesso!');
                } catch (error) {
                    toast.error('Erro ao limpar cache.');
                }
            },
            async saveDepoimentos() {
                const putData = [];
                const postData = [];

                this.depoimentos.forEach((depoimento, index) => {
                    const item = {
                        name: depoimento.name,
                        description: depoimento.description,
                        photo: depoimento.photo,
                    };

                    if (depoimento.id) {
                        item.id = depoimento.id;
                        putData.push(item);
                    } else {
                        postData.push(item);
                    }
                });

                try {
                    if (putData.length > 0) {
                        await apiTestimony.putTestomonytData(
                            this.token,
                            putData
                        );
                    }
                    if (postData.length > 0) {
                        await apiTestimony.postTestomonytData(
                            this.token,
                            postData
                        );
                    }
                    this.getDataTestimony();
                } catch (error) {
                    toast.error('Erro ao salvar depoimentos');
                    console.error('Erro ao salvar depoimentos:', error);
                }
            },
            async getCollections() {
                try {
                    const response = await apiCollections.getCollection(
                        this.token
                    );
                    const sortedCollections = response.sort((a, b) => {
                        const orderA = Number(a.order) || 0;
                        const orderB = Number(b.order) || 0;
                        return orderA - orderB;
                    });
                    this.allCollections = [...sortedCollections];
                    console.log(this.allCollections);
                } catch (error) {
                    toast.error('Erro ao obter dados das coleções');
                    console.error('Erro ao obter dados das coleções:', error);
                }
            },
            async getContetData() {
                try {
                    console.log('=== INICIANDO getContetData ===');
                    const response = await apiSiteContent.getContentData(
                        this.token
                    );
                    this.listContents = response;
                    console.log('=== DADOS RECEBIDOS DA API ===');
                    console.log('Quantidade de itens:', response?.length);
                    console.log('Dados completos:', response);
                    
                    // Log detalhado de cada item
                    if (response && response.length > 0) {
                        response.forEach((item, index) => {
                            console.log(`Item ${index + 1}:`, {
                                id: item.id,
                                type: item.type,
                                title: item.title,
                                status: item.status,
                                order: item.order
                            });
                        });
                    }
                    
                    // Primeiro, desativa todos os blocos
                    this.bloco1_active = false;
                    this.bloco2_active = false;
                    this.bloco3_active = false;
                    this.bloco4_active = false;
                    
                    // Limpa os dados dos blocos
                    this.bloco1_title = '';
                    this.bloco1_description = '';
                    this.bloco1_banner = '';
                    this.bloco1_bannerPreview = null;
                    this.bloco1_link = '';
                    
                    this.bloco2_title = '';
                    
                    this.bloco3_title = '';
                    this.bloco3_description = '';
                    this.bloco3_banner = '';
                    this.bloco3_bannerPreview = null;
                    this.bloco3_link = '';
                    
                    this.bloco4_title = '';
                    
                    console.log('=== ATIVANDO APENAS BLOCOS EXISTENTES ===');
                    
                    if (response.length > 0) {
                        // Processa cada bloco retornado pela API
                        response.forEach((item, index) => {
                            console.log(`Processando item ${index + 1}:`, {
                                type: item.type,
                                title: item.title,
                                status: item.status
                            });
                            
                            switch (item.type) {
                                case 1: // Banner
                                    this.bloco1_active = item.status == 1 ? true : false;
                                    this.bloco1_banner = item.pathImage;
                                    this.bloco1_bannerPreview = item.pathImageFinal;
                                    this.bloco1_title = item.title;
                                    this.bloco1_link = item.url;
                                    this.bloco1_description = item.description;
                                    console.log('✅ Bloco 1 (Banner) ativado:', this.bloco1_active);
                                    break;
                                    
                                case 2: // Cursos
                                    this.bloco2_active = item.status == 1 ? true : false;
                                    this.bloco2_title = item.title;
                                    console.log('✅ Bloco 2 (Cursos) ativado:', this.bloco2_active);
                                    break;
                                    
                                case 3: // Banner 2 (Conteúdo Institucional)
                                    this.bloco3_active = item.status == 1 ? true : false;
                                    this.bloco3_banner = item.pathImage;
                                    this.bloco3_bannerPreview = item.pathImageFinal;
                                    this.bloco3_title = item.title;
                                    this.bloco3_link = item.url;
                                    this.bloco3_description = item.description;
                                    console.log('✅ Bloco 3 (Banner 2) ativado:', this.bloco3_active);
                                    break;
                                    
                                case 4: // Depoimentos
                                    this.bloco4_active = item.status == 1 ? true : false;
                                    this.bloco4_title = item.title;
                                    console.log('✅ Bloco 4 (Depoimentos) ativado:', this.bloco4_active);
                                    break;
                                    
                                default:
                                    console.warn('⚠️ Tipo de bloco desconhecido:', item.type);
                            }
                        });
                        
                        console.log('=== STATUS FINAL DOS BLOCOS ===');
                        console.log('Bloco 1 (Banner):', this.bloco1_active);
                        console.log('Bloco 2 (Cursos):', this.bloco2_active);
                        console.log('Bloco 3 (Banner 2):', this.bloco3_active);
                        console.log('Bloco 4 (Depoimentos):', this.bloco4_active);
                    }
                } catch (error) {
                    toast.error('Erro ao obter dados dos blocos');
                    console.error('Erro ao obter dados dos blocos:', error);
                }
            },
            async editSocialMedia() {
                const socialData = [];
                const newItems = [];

                console.log('=== EDITANDO SOCIAL MEDIA ===');
                console.log('activeSocial:', this.activeSocial);
                console.log('linkSocial:', this.linkSocial);
                console.log('data (itens existentes):', this.data);

                this.linkSocial.forEach((link, index) => {
                    const id = this.data.find(item => item.type === index)?.id;
                    const status = this.activeSocial[index] ? 1 : 0;
                    const url = link ? link : null;
                    const type = index;
                    const name = this.names[index];

                    console.log(`Processando ${name} (index ${index}):`, {
                        link,
                        activeSocial: this.activeSocial[index],
                        status,
                        id,
                        hasExistingItem: !!id
                    });

                    if (id) {
                        // Item existente - sempre envia PUT (mesmo para desativar)
                        socialData.push({ id, name, type, url, status });
                        console.log(`✅ ${name}: Enviando PUT (item existente)`);
                    } else if (this.activeSocial[index] && link !== '') {
                        // Novo item - só cria se estiver ativo e com link
                        newItems.push({ name, type, url, status });
                        console.log(`➕ ${name}: Enviando POST (novo item)`);
                    } else {
                        console.log(`⏭️ ${name}: Ignorando (sem item existente e não ativo)`);
                    }
                });
                try {
                    if (socialData.length > 0) {
                        // Atualiza os itens existentes
                        await apiSiteSocialMidia.putSocialMidiastData(
                            this.token,
                            socialData
                        );
                    }

                    if (newItems.length > 0) {
                        // Cria novos itens
                        await apiSiteSocialMidia.postSocialMidiastData(
                            this.token,
                            newItems
                        );
                    }

                    // Recarrega os dados após a atualização/criação
                    this.getDataSocialMedia();
                } catch (error) {
                    toast.error('Erro ao atualizar as mídias sociais');
                    console.error(error);
                }
            },
            async getDataSocialMedia() {
                try {
                    const response =
                        await apiSiteSocialMidia.getSocialMidiastData(
                            this.token
                        );
                    
                    console.log('=== DADOS RECEBIDOS DA API SOCIAL MEDIA ===');
                    console.log('Response completa:', response);
                    
                    this.data = response;
                    this.bloco5_active = response.length > 0 ? true : false;
                    
                    // Limpa os arrays antes de preencher
                    this.activeSocial = Array(6).fill(false);
                    this.linkSocial = Array(6).fill('');
                    
                    console.log('Arrays limpos:');
                    console.log('activeSocial:', this.activeSocial);
                    console.log('linkSocial:', this.linkSocial);
                    
                    this.data.forEach((item, index) => {
                        console.log(`Processando item ${index}:`, {
                            type: item.type,
                            name: item.name,
                            status: item.status,
                            url: item.url
                        });
                        
                        this.activeSocial[item.type] = item.status === 1;
                        this.linkSocial[item.type] = item.url;
                    });
                    
                    console.log('Arrays após processamento:');
                    console.log('activeSocial:', this.activeSocial);
                    console.log('linkSocial:', this.linkSocial);
                    
                } catch (error) {
                    toast.error('Erro ao obter dados das mídias sociais');
                    console.error(error);
                }
            },
            nextSlide() {
                if (this.depoimentos.length === 0) return;
                this.currentIndex =
                    (this.currentIndex + 1) % this.depoimentos.length;
            },
            prevSlide() {
                if (this.depoimentos.length === 0) return;
                this.currentIndex =
                    (this.currentIndex - 1 + this.depoimentos.length) %
                    this.depoimentos.length;
            },
            async getDataTestimony() {
                try {
                    const response = await apiTestimony.getTestomonytData(
                        this.token
                    );
                    console.debug(response.data);
                    if (response.data.length > 0) {
                        this.depoimentos = response.data;
                        this.currentIndex = 0; // Reinicia o índice ao carregar
                    }
                } catch (error) {
                    toast.error('Erro ao obter dados dos depoimentos');
                    console.error(error);
                }
            },
            // async getDataTestimony(){
            //   try {
            //     const response = await apiTestimony.getTestomonytData(this.token);
            //     console.debug(response.data)
            //     if(response.data.length > 0){
            //       this.depoimentos = response.data;
            //     } else {
            //       // this.depoimentos = [];
            //     }
            //   } catch (error) {
            //     console.error(error);
            //   }
            // }
        },
        components: {},
        created() {
            this.getContetData();
            this.getDataSocialMedia();
            this.getDataTestimony();
            this.getCollections();
        },
    };
</script>
<style scoped>
    @import '@/css/weeduc/admin/content.css';
    .content-button.site {
        position: fixed;
        right: 32px;
        bottom: 32px;
        z-index: 100 !important;
    }
    button.btn.btn-block.btn-content {
        max-width: 250px !important;
        padding: 8px 40px !important;
    }
    @media (max-width: 768px) {
        /* .site_content.weeduc-admin-content.main-container {
            padding: 0px 0px 0px 10px !important;
        } */
        button.btn.btn-block.btn-content {
            max-width: 100% !important;
            padding: 8px 40px !important;
        }
        .site_content.weeduc-admin-content.main-container
            .banner-content.cursos.d-flex.align-items-center {
            display: flex;
            flex-direction: column;
        }
        .global-site-weeduc
            .weeduc-admin-content
            .config-form.primary.col-12.itens-courses
            .banner-text {
            width: 100% !important;
        }
        .global-site-weeduc .weeduc-admin-content .depoimento-image img {
            width: 40px !important;
        }
        .global-site-weeduc .weeduc-admin-content .depoimentos-slider {
            gap: 10px !important;
        }
        .weeduc-admin-content .redes-sociais .rede-social svg {
            color: #250891;
        }
    }
</style>
